import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { SectionsModule } from './sections/sections.module';
import { ComponentsModule } from './components/components.module';

import { AppComponent } from './app.component';

import { PresentationModule } from './presentation/presentation.module';
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { AppEffects } from './app.effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { HomeComponent } from './containers/home/home.component';
import {AuthenticationRouter} from './authentication/authentication-routing.module';
import {AuthenticationModule} from './authentication/authentication.module';
import {AngularFireModule} from '@angular/fire';
import {SharedModule} from './shared/shared.module';
import {Page404Component} from './containers/page404/page404.component';
import {NavbarComponent} from './shared/shared/navbar/navbar.component';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {UserRouterModule} from './user/user.router';
import {UserModule} from './user/user.module';
import {ToastyModule} from 'ng2-toasty';
import {environment} from '../environments/environment';
import {LoadingIndicatorModule} from './loading-indicator/loading-indicator.module';
import {CommonModule} from '@angular/common';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        Page404Component,
        NavbarComponent,
    ],
    imports: [
        BrowserAnimationsModule,
        CommonModule,
        NgbModule,
        ToastyModule.forRoot(),
        LoadingIndicatorModule,
        FormsModule,
        RouterModule,
        AuthenticationRouter,
        UserRouterModule,
        UserModule,
        AppRoutingModule,
        PresentationModule,
        SectionsModule,
        ComponentsModule,
        AuthenticationModule,
        SharedModule,

        StoreModule.forRoot(reducers, { metaReducers }),
        EffectsModule.forRoot([AppEffects]),
        StoreRouterConnectingModule.forRoot(),
        AngularFireModule.initializeApp(environment.firebase),
        StoreDevtoolsModule.instrument({ maxAge: 25 })

    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }
